import {KanbanBoard} from '../components/KanbanBoard'
import {CurrentRound} from '../components/CurrentRound'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../../auth'
import {useEffect, useState} from 'react'
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd'
import {
  createInvestorCSV,
  deleteRoundById,
  exportAllInvestorUsers,
  getActiveRound,
  getAllColumnsFromRoundIdIU,
  getAllRounds,
  updateActiveRoundInCompany,
  updateColumnIndex,
} from '../core/_requests'
import {AddRoundModal} from './AddRoundModal'
// import {Dropdown, Modal} from 'react-bootstrap'
import {Dropdown, DropdownButton, Modal} from 'react-bootstrap'
import {AddInvestorModal} from './AddInvestorModal'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {Filter} from '../../widgets/components/General/Filter'
import {getInvestors} from '../../investor-database/core/_requests'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import {CSVBoxButton} from '@csvbox/react'
import {useThemeMode} from '../../../../_metronic/partials'
import {roleValues} from '../../../core/_constants'
import {companyData} from '../../profile/core/_requests'
import Skeleton from 'react-loading-skeleton'
// import {SelectInput} from '../../widgets/components/Input/SelectInput'
import '../styles/InvestorCrm.scss'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

export const InvestorDetailsScreen = () => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const {companyId, currentUser, billingData, setShowBillingModal, role} = useAuth()
  const [activeRound, setActiveRound] = useState<any>()
  const [allRounds, setAllRounds] = useState<any>()
  const [getAllColumns, setGetAllColumns] = useState<any>([])
  const [modalShow, setModalShow] = useState(false)
  const [selectedRoundId, setSelectedRoundId] = useState<any>()
  const [show, setShow] = useState(false)

  const [columnDetails, setColumnDetails] = useState<any>()
  const [search, setSearch] = useState<string | undefined>()
  const [addInvestorModalShow, setAddInvestorModalShow] = useState(false)
  const [allInvestors, setAllInvestors] = useState<any>()
  const [loading, setLoading] = useState(true)
  const [addModal, setAddModal] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  const [investorCrmFilter, setInvestorCrmFilter] = useState<boolean>(false)
  const [sort_by_investor, set_sort_by_investor] = useState<string | undefined>(undefined)
  const [sort_order_investor, set_sort_order_investor] = useState<string | undefined>(undefined)
  const [isEditRound, setIsEditRound] = useState(false)

  const [searchInvestor, setSearchInvestor] = useState<string>('')
  const [currency, setCurrency] = useState<number>(0)

  const [commitedInvestors, setCommitedInvestors] = useState<any[]>([])

  useEffect(() => {
    if (getAllColumns.length > 0) {
      getAllColumns.forEach((column: any) => {
        if (column.columnName === 'Commited') {
          if (column.investorUsers.length > 0) {
            const filesArray = column.investorUsers.map((investor: any) => ({
              investorUserId: investor.investorUserId,
              file: investor.file ? investor.file.name : null,
            }))
            setCommitedInvestors(filesArray)
          }
        }
      })
    }
  }, [getAllColumns]) // eslint-disable-line react-hooks/exhaustive-deps

  const getCompanyData = async () => {
    try {
      if (companyId) {
        const {
          data: {success, data, errors},
        } = await companyData(companyId)
        if (success) {
          setCurrency(data.currencyId)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getCompanyData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getActiveRoundFromApi = async () => {
    try {
      // if (companyId && role && role !== roleValues.BILLING) {
      if (companyId) {
        const {
          data: {success, data: apiActiveRound, errors},
        } = await getActiveRound(companyId)
        if (success) {
          setActiveRound(apiActiveRound)
          setSelectedRoundId(activeRound?.roundId)
        } else {
          // Show Add Round Modal
          setLoading(false)
          setModalShow(true)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const getRoundsFromApi = async () => {
      try {
        // if (companyId && role && role !== roleValues.BILLING) {
        if (companyId) {
          const {
            data: {success, data: apiRounds},
          } = await getAllRounds(companyId)
          if (success) {
            setAllRounds(apiRounds)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    getRoundsFromApi()
    getActiveRoundFromApi()
  }, [companyId, activeRound?.roundId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (allRounds && activeRound) {
      setSelectedRoundId(
        allRounds[allRounds?.findIndex((round: any) => round?.roundId === activeRound?.roundId)]
          ?.roundId
      )
    }
  }, [activeRound?.roundId, allRounds, activeRound]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if (selectedRoundId && role && role !== roleValues.BILLING) {
    if (selectedRoundId) {
      getColumnsFromRoundIdApi()
    }
  }, [selectedRoundId, search, sort_by_investor, sort_order_investor, role]) // eslint-disable-line react-hooks/exhaustive-deps

  //done
  const getColumnsFromRoundIdApi = async () => {
    try {
      // if (selectedRoundId && role && role !== roleValues.BILLING) {
      if (selectedRoundId) {
        const {
          data: {success, data: allColumns},
        } = await getAllColumnsFromRoundIdIU(
          selectedRoundId,
          search,
          sort_by_investor,
          sort_order_investor
        )
        if (success) {
          setGetAllColumns(allColumns)
        }
      }
    } catch (error) {
      setGetAllColumns([])
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  //getInvestorAPI
  useEffect(() => {
    const getInvestorsData = async () => {
      try {
        const {
          data: {
            success,
            data: {data: allApiInvestors},
          },
        } = await getInvestors(searchInvestor, companyId, 1, 12)
        if (success) {
          setAllInvestors(allApiInvestors)
        }
      } catch (error) {
        console.log(error)
      }
    }
    // if (companyId && role && role !== roleValues.BILLING) {
    if (companyId) {
      getInvestorsData()
    }
  }, [companyId, searchInvestor, role])

  const onSearchChange = (value: string) => {
    setSearchInvestor(value)
  }

  useEffect(() => {
    setSelectedRoundId(
      allRounds?.[allRounds?.findIndex((round: any) => round.roundId === activeRound?.roundId)]
        ?.roundId
    )
  }, [activeRound?.roundId, allRounds])

  const onExportInvestorUsers = async () => {
    if (selectedRoundId && role === roleValues.OWNER) {
      const {
        data: {data: values, success, errors},
      } = await exportAllInvestorUsers({roundId: selectedRoundId})
      if (success) {
        toast.success(formatMessage({id: 'Downloading all investor users'}))
        const url = window.URL.createObjectURL(new Blob([values]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'investorUsers.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ExportAllInvestorUsersSuccessful,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: selectedRoundId || '',
            },
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ExportAllInvestorUsersFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: selectedRoundId || '',
              error: errors[0],
            },
          },
        })
      }
    }
  }

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return
    }
    const items = Array.from(getAllColumns)
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)

    setGetAllColumns(items)

    handleUpdateIndex(
      items.map((col: any, index: number) => {
        return {columnId: col.columnId, index}
      })
    )
  }

  const handleUpdateIndex = async (columns: any[]) => {
    try {
      const {
        data: {success},
      } = await updateColumnIndex(columns, selectedRoundId)

      if (success) {
        getColumnsFromRoundIdApi()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMUpdateColumnIndexSuccessful,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: selectedRoundId || '',
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMUpdateColumnIndexFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            round_id: selectedRoundId || '',
            error: error,
          },
        },
      })
    }
  }

  const handleOnChangeRound = async (round: any) => {
    try {
      if (companyId && round) {
        const {
          data: {success},
        } = await updateActiveRoundInCompany({companyId, activeRound: round})

        if (success) {
          getActiveRoundFromApi()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMUpdateActiveRoundInCompanySuccessful,
              action: 'normal',
              metadata: {
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                active_round: round || '',
              },
            },
          })
        }
      }
    } catch (error) {
      console.log(error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMUpdateActiveRoundInCompanyFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            active_round: round || '',
            error: error,
          },
        },
      })
    }
  }

  const addRoundcolumn = async () => {
    setShow(true)
    setColumnDetails({
      name: '',
      color: '',
    })
  }

  const DeleteRound = async () => {
    try {
      setDeleteLoading(true)
      const {
        data: {success, errors},
      } = await deleteRoundById(activeRound.roundId)
      if (success) {
        toast.success(formatMessage({id: 'Round Deleted'}))
        getActiveRoundFromApi()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMDeleteRoundSuccessful,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: activeRound.roundId || '',
            },
          },
        })
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMDeleteRoundFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              round_id: activeRound.roundId || '',
              error: errors[0],
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CRMDeleteRoundFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            round_id: activeRound.roundId || '',
            error: err,
          },
        },
      })
    } finally {
      setDeleteLoading(false)
      setDeleteShowModal(!showDeleteModal)
    }
  }

  const editRound = () => {
    setModalShow(!modalShow)
    setIsEditRound(true)
  }

  const importedFileUpload = async (data: any) => {
    if (companyId) {
      data.investors.forEach((investor: any) => {
        if (investor.fund_type) {
          investor.fund_type = JSON.stringify(investor.fund_type.split(','))
        }
        const contacts = []

        for (let i = 1; i <= 3; i++) {
          const designation = investor[`contact${i}_designation`]
          const email = investor[`contact${i}_email`]
          const name = investor[`contact${i}_name`]
          const phone = investor[`contact${i}_phone`]
          const linkedin_url = investor[`contact${i}_linkedin_url`]

          if (designation || email || name || phone || linkedin_url) {
            contacts.push({designation, email, name, phone, linkedin_url})
          }
          delete investor[`contact${i}_designation`]
          delete investor[`contact${i}_email`]
          delete investor[`contact${i}_name`]
          delete investor[`contact${i}_phone`]
          delete investor[`contact${i}_linkedin_url`]
        }

        investor.investorUser = contacts
      })
      const {
        data: {success, errors},
      } = await createInvestorCSV(data, +companyId)
      if (success) {
        toast.success(formatMessage({id: 'Successfully uploaded investors from the file.'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMCreateInvestorFromCsvSuccessful,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
            },
          },
        })
      } else if (errors) {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CRMCreateInvestorFromCsvFailed,
            action: 'normal',
            metadata: {
              user_id: currentUser?.userId,
              email: currentUser?.email,
              company_id: companyId,
              error: errors[0],
            },
          },
        })
      }
    }
  }
  const addRound = () => {
    // setColumnsDetails({})
    setIsEditRound(false)
    setModalShow(true)
  }
  return (
    <>
      <Filter
        investorCrmFilter={investorCrmFilter}
        setInvestorCrmFilter={setInvestorCrmFilter}
        set_sort_by_investor={set_sort_by_investor}
        set_sort_order_investor={set_sort_order_investor}
      />
      <div className='investor-screen px-5 py-0 h-100'>
        {/* {loading && <Spinner />} */}
        <div className='d-flex justify-content-between px-1 row'>
          <div className='col-12 col-md-9'>
            <h4 className='mb-4'> {formatMessage({id: 'Investor CRM'})}</h4>
            <p className='fw-semibold align-items-center d-flex font-size-12 text-primary'>
              <Link to='/' className='text-primary'>
                {formatMessage({id: 'Home'})}
              </Link>
              <span className='h-1px bullet mx-2'></span>
              <span className='text-muted font-size-12'>
                {' '}
                {formatMessage({id: 'Investor CRM'})}
              </span>
            </p>
          </div>
          <div className='d-flex col-12 col-md-3 align-items-center justify-content-md-end mb-md-2 mb-3 px-2'>
            {loading ? (
              <div className='w-100 w-md-75'>
                <Skeleton
                  height={35}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </div>
            ) : (
              <button
                className='border border-primary btn btn-primary height-36 d-flex align-items-center font-size-13 w-100 w-md-auto justify-content-center'
                onClick={() => setAddInvestorModalShow(true)}
              >
                {formatMessage({id: 'Add Contact'})}
              </button>
            )}
          </div>
        </div>
        <div>
          {activeRound && (
            <CurrentRound
              activeRound={activeRound}
              setModalShow={setModalShow}
              show={show}
              setShow={setShow}
              selectedRoundId={selectedRoundId}
              setGetAllColumns={setGetAllColumns}
              columnDetails={columnDetails}
              setColumnsDetails={setColumnDetails}
              setIsEditRound={setIsEditRound}
              editRound={editRound}
              commitedInvestors={commitedInvestors}
              initialLoading={loading}
            />
          )}

          {activeRound && (
            <div className='d-flex justify-content-between flex-md-row flex-column  ms-0 mt-2'>
              <div className=' d-flex flex-md-row gap-2 align-items-center w-md-75'>
                <div
                  className='gap-md-2 gap-0 w-50 w-md-200px dropdown-btn-container rounded'
                  style={{maxWidth: '220px !important'}}
                >
                  {loading ? (
                    <div className='min-w-md-100px'>
                      <Skeleton
                        height={42}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  ) : (
                    <DropdownButton
                      title={activeRound.roundName}
                      // className='bg-white p-0 font-weight-400 font-size-12 cursor-pointer rounded dropdown-btn-crm '
                      className={
                        `bg-white btn-hover-white p-0 font-weight-400 font-size-12 cursor-pointer rounded dropdown-btn-crm ` +
                        (mode !== 'dark' ? `` : `dropdown-btn-crm-dark`)
                      }
                      onSelect={(e) => handleOnChangeRound(parseInt(e as string))}
                    >
                      {allRounds &&
                        activeRound &&
                        allRounds?.map(({roundId, roundName}: any) => (
                          <Dropdown.Item eventKey={roundId} key={roundId}>
                            {roundName}
                          </Dropdown.Item>
                        ))}
                    </DropdownButton>
                  )}
                </div>
                <div className=' d-flex w-50 w-md-auto'>
                  {loading ? (
                    <div className='min-w-md-100px w-100'>
                      <Skeleton
                        height={42}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  ) : (
                    <>
                      <button
                        className='border border-primary rounded bg-body text-primary fs-7 px-6 w-100 py-3'
                        onClick={addRound}
                      >
                        {formatMessage({id: 'Add Round'})}
                      </button>
                      <span className='align-self-center'>
                        <ToolTipUI
                          tooltipText={formatMessage({
                            id: 'Click here to add a new round to your fundraising cycle',
                          })}
                        />
                      </span>
                    </>
                  )}
                </div>
              </div>
              <div className='d-flex justify-content-between my-2 p-0 gap-3'>
                {loading ? (
                  <>
                    <div className='d-flex gap-2 w-100'>
                      <div className='w-25 min-w-md-100px'>
                        <Skeleton
                          height={38}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='w-25 min-w-md-100px'>
                        <Skeleton
                          height={38}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='w-25 min-w-md-100px'>
                        <Skeleton
                          height={38}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                      <div className='w-25 min-w-md-100px'>
                        <Skeleton
                          height={38}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='height-36px border bg-white d-flex align-items-center rounded'>
                      <button
                        className='text-clr88 btn btn-sm btn-flex fw-semibold font-size-12'
                        id='fc-toogle'
                        title='Sort and Filter'
                        data-bs-toggle='tooltip'
                        data-bs-placement='left'
                        data-bs-dismiss='click'
                        data-bs-trigger='hover'
                        onClick={() => setInvestorCrmFilter(true)}
                      >
                        <KTSVG
                          path={
                            sort_by_investor && sort_order_investor
                              ? '/media/icons/duotune/general/gen031_selected.svg'
                              : '/media/icons/duotune/general/gen031.svg'
                          }
                          className='svg-icon-6 svg-icon-muted me-1'
                        />
                        {sort_by_investor && sort_order_investor
                          ? formatMessage({id: 'Filter*'})
                          : formatMessage({id: 'Filter'})}
                      </button>
                    </div>
                    <div className='w-100'>
                      <form
                        data-kt-search-element='form'
                        className=' align-items-center d-flex position-relative'
                        autoComplete='off'
                      >
                        <KTSVG
                          path='/media/icons/duotune/general/gen021.svg'
                          className='svg-icon-3 position-absolute ms-3'
                        />
                        <input
                          type='text'
                          className='bg-body form-control form-control-flush ps-10 height-36px rounded font-weight-400 text-clrA1'
                          name='search'
                          placeholder={formatMessage({id: 'Search...'})}
                          data-kt-search-element='input'
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </form>
                    </div>
                    {/* {role && role !== roleValues.BILLING && role !== roleValues.FRM && ( */}
                    {
                      <CSVBoxButton
                        licenseKey={process.env.REACT_APP_CSVBOX_LICENSE_KEY}
                        user={{
                          user_id: `${currentUser?.userId}`,
                        }}
                        onImport={(result: any, data: any) => {
                          if (result) {
                            const sendData = {
                              investors: data.rows,
                            }
                            importedFileUpload(sendData)
                          } else {
                            toast.error(formatMessage({id: 'File import failed, Please try later'}))
                          }
                        }}
                        render={(launch: any) => {
                          return (
                            <>
                              {billingData?.subscription_items[0].item_price_id.split('-')[0] ===
                              'Basic' ? (
                                <div
                                  // className={`align-items-center bg-body d-flex justify-content-center px-2 height-36px rounded h-100 cursor-pointer ${
                                  //   (role === roleValues.CURATOR || role === roleValues.IRM) &&
                                  //   'disableDiv'
                                  // }`}
                                  className={`align-items-center bg-body d-flex justify-content-center px-2 height-36px rounded h-100 cursor-pointer`}
                                  onClick={() => setShowBillingModal(true)}
                                >
                                  {mode === 'dark' ? (
                                    <img
                                      src={toAbsoluteUrl('/media/icons/investor/lock.svg')}
                                      alt='lock icon'
                                      width={15}
                                      className={`me-2 `}
                                      height={15}
                                    />
                                  ) : (
                                    <img
                                      src={toAbsoluteUrl('/media/icons/investor/darkLock.svg')}
                                      alt='lock icon'
                                      width={15}
                                      className={`me-2 `}
                                      height={15}
                                    />
                                  )}

                                  <i className='fa-cloud-arrow-up fa-sharp fa-solid fs-2'></i>
                                </div>
                              ) : (
                                <div
                                  className='align-items-center bg-white d-flex justify-content-center width-36 height-36px rounded h-100 cursor-pointer'
                                  onClick={launch}
                                >
                                  <i className='fa-cloud-arrow-up fa-sharp fa-solid fs-2'></i>
                                </div>
                              )}
                            </>
                          )
                        }}
                      ></CSVBoxButton>
                    }
                    <CSVBoxButton
                      licenseKey={process.env.REACT_APP_CSVBOX_LICENSE_KEY}
                      user={{
                        user_id: `${currentUser?.userId}`,
                      }}
                      onImport={(result: any, data: any) => {
                        if (result) {
                          const sendData = {
                            investors: data.rows,
                          }
                          importedFileUpload(sendData)
                        } else {
                          toast.error(formatMessage({id: 'File import failed, Please try later'}))
                        }
                      }}
                      render={(launch: any) => {
                        return (
                          <div className='align-items-center bg-body d-flex justify-content-center width-36 height-36px rounded h-100 cursor-pointer'>
                            <Dropdown className='dropdown-container'>
                              <Dropdown.Toggle className='bi bi-three-dots-vertical p-1 width-36 height-36px'></Dropdown.Toggle>
                              <Dropdown.Menu className='m-2 py-0'>
                                {/* {role && role !== roleValues.BILLING && role !== roleValues.FRM && ( */}
                                {
                                  <>
                                    {billingData?.subscription_items[0].item_price_id.split(
                                      '-'
                                    )[0] === 'Basic' ? (
                                      <Dropdown.Item
                                        className={`text-dark font-size-12 primary-color-hover d-flex`}
                                        onClick={() => setShowBillingModal(true)}
                                      >
                                        {mode === 'dark' ? (
                                          <img
                                            src={toAbsoluteUrl('/media/icons/investor/lock.svg')}
                                            alt='lock icon'
                                            width={15}
                                            className={`me-2 `}
                                            height={15}
                                          />
                                        ) : (
                                          <img
                                            src={toAbsoluteUrl(
                                              '/media/icons/investor/darkLock.svg'
                                            )}
                                            alt='lock icon'
                                            width={15}
                                            className={`me-2 `}
                                            height={15}
                                          />
                                        )}
                                        <p className='mb-0'>{formatMessage({id: 'Import CSV'})}</p>
                                      </Dropdown.Item>
                                    ) : (
                                      <Dropdown.Item
                                        className='text-dark font-size-12 primary-color-hover'
                                        onClick={launch}
                                      >
                                        <p className='mb-0'>{formatMessage({id: 'Import CSV'})}</p>
                                      </Dropdown.Item>
                                    )}{' '}
                                  </>
                                }

                                {role === roleValues.OWNER && (
                                  <>
                                    {billingData &&
                                    billingData?.subscription_items[0].item_price_id.split(
                                      '-'
                                    )[0] !== 'Gold' ? (
                                      <Dropdown.Item
                                        className='text-dark d-flex font-size-12'
                                        onClick={() => setShowBillingModal(true)}
                                      >
                                        {mode === 'dark' ? (
                                          <img
                                            src={toAbsoluteUrl('/media/icons/investor/lock.svg')}
                                            alt='lock icon'
                                            width={15}
                                            className={`me-2 `}
                                            height={15}
                                          />
                                        ) : (
                                          <img
                                            src={toAbsoluteUrl(
                                              '/media/icons/investor/darkLock.svg'
                                            )}
                                            alt='lock icon'
                                            width={15}
                                            className={`me-2 `}
                                            height={15}
                                          />
                                        )}
                                        <p className='mb-0'>
                                          {formatMessage({id: 'Export to CSV'})}
                                        </p>
                                      </Dropdown.Item>
                                    ) : (
                                      <Dropdown.Item
                                        className='text-dark font-size-12 primary-color-hover'
                                        onClick={onExportInvestorUsers}
                                      >
                                        <p className='mb-0'>
                                          {formatMessage({id: 'Export to CSV'})}
                                        </p>
                                      </Dropdown.Item>
                                    )}
                                  </>
                                )}

                                <Dropdown.Item
                                  className='text-dark font-size-12 primary-color-hover'
                                  onClick={() => setAddModal(!addModal)}
                                >
                                  <p className='mb-0'>{formatMessage({id: 'Rearrange Columns'})}</p>
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className='text-dark font-size-12 primary-color-hover'
                                  onClick={addRoundcolumn}
                                >
                                  <p className='mb-0 '>{formatMessage({id: 'Add new Column'})}</p>
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className='font-size-12 primary-color-hover text-danger'
                                  onClick={() => setDeleteShowModal(!showDeleteModal)}
                                >
                                  {formatMessage({id: 'Delete Round'})}
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className='font-size-12 primary-color-hover border border-none'
                                  onClick={() => editRound()}
                                >
                                  {formatMessage({id: 'Edit Round'})}
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                            <div>
                              <Modal
                                show={addModal}
                                onHide={() => setAddModal(!addModal)}
                                aria-labelledby='contained-modal-title-vcenter'
                                centered
                              >
                                <Modal.Header closeButton>
                                  <h2> {formatMessage({id: 'Rearrange Columns'})}</h2>
                                </Modal.Header>
                                <Modal.Body>
                                  <ul>
                                    {
                                      <DragDropContext onDragEnd={onDragEnd}>
                                        <Droppable droppableId='columns'>
                                          {(provided) => (
                                            <div
                                              ref={provided.innerRef}
                                              {...provided.droppableProps}
                                            >
                                              {getAllColumns.map((column: any, index: number) => (
                                                <Draggable
                                                  key={column.columnId}
                                                  draggableId={column.columnId.toString()}
                                                  index={index}
                                                >
                                                  {(provided) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className='d-flex gap-4 drag-drop-box mb-4'
                                                    >
                                                      <div>
                                                        <img
                                                          src={
                                                            '/media/icons/investor/hamburger.svg'
                                                          }
                                                          alt=''
                                                        />
                                                      </div>
                                                      <div>
                                                        <h4>{column.columnName}</h4>
                                                      </div>
                                                    </div>
                                                  )}
                                                </Draggable>
                                              ))}
                                              {provided.placeholder}
                                            </div>
                                          )}
                                        </Droppable>
                                      </DragDropContext>
                                    }
                                  </ul>
                                </Modal.Body>
                              </Modal>
                              <Modal
                                show={showDeleteModal}
                                onHide={() => setDeleteShowModal(false)}
                                aria-labelledby='contained-modal-title-vcenter'
                                centered
                              >
                                <Modal.Header closeButton>
                                  <h2>{formatMessage({id: 'Delete Round'})}</h2>
                                </Modal.Header>
                                <Modal.Body>
                                  <p>
                                    {formatMessage({
                                      id: 'Please note that the delete round is a permanent action and cannot be undone. As a result,you will no longer have the round. Are you certain you wish to proceed with this',
                                    })}
                                  </p>
                                </Modal.Body>
                                <Modal.Footer>
                                  <BasicButton
                                    height='44px'
                                    border='none'
                                    color='#F5F8FA'
                                    textColor='#7E8299'
                                    padding='12px 16px'
                                    onClick={() => {
                                      setDeleteShowModal(!showDeleteModal)
                                    }}
                                    buttonText='Cancel'
                                    minWidth={56}
                                  />

                                  <BasicButton
                                    height='44px'
                                    border='1px solid #4776E6'
                                    color='#4776E6'
                                    textColor='white'
                                    padding='12px 24px'
                                    onClick={() => {
                                      DeleteRound()
                                    }}
                                    buttonText='Confirm Delete'
                                    minWidth={56}
                                    loading={deleteLoading}
                                    disabled={deleteLoading}
                                  />
                                </Modal.Footer>
                              </Modal>
                            </div>
                          </div>
                        )
                      }}
                    ></CSVBoxButton>
                  </>
                )}
              </div>
            </div>
          )}

          <div></div>

          <div className='row flex-nowrap ms-0'>
            <KanbanBoard
              allColumns={getAllColumns}
              selectedRoundId={selectedRoundId}
              show={show}
              setShow={setShow}
              setColumnDetails={setColumnDetails}
              setGetAllColumns={setGetAllColumns}
              setAddInvestorModalShow={setAddInvestorModalShow}
              getActiveRoundFromApi={getActiveRoundFromApi}
              currency={currency}
              loading={loading}
            />
          </div>

          <AddRoundModal
            modalShow={modalShow}
            setModalShow={setModalShow}
            currency={currency}
            setActiveRound={setActiveRound}
            setSelectedRoundId={setSelectedRoundId}
            activeRound={activeRound}
            setAllRounds={setAllRounds}
            isEditRound={isEditRound}
            totalRounds={allRounds?.length}
            getCompanyData={getCompanyData}
          />
          <AddInvestorModal
            addInvestorModalShow={addInvestorModalShow}
            setAddInvestorModalShow={setAddInvestorModalShow}
            allRounds={allRounds}
            allInvestors={allInvestors}
            activeRound={selectedRoundId}
            setGetAllColumns={setGetAllColumns}
            columnDetails={columnDetails}
            refreshActiveRound={getActiveRoundFromApi}
            onSearchChange={onSearchChange}
          />
        </div>
      </div>
    </>
  )
}
